import Address from "../../components/Address";
import { MenuBar } from "../../components/MenuBar";
import youtubeLink from "../../images/utub.png";
import React, { useEffect, useState } from "react";
import "../Main.css";
import { VideoList } from "./VideoList";
import { getYoutubePageCount } from "../../services/VideoAPI";

export const Videos = () => {
  const [selectedPage, setSelectedPage] = useState();
  const [youtubeCount, setYoutubeCount] = useState([]);

  const changePage = (selected) => {
    window.location.href = `/video?page=${selected.selected + 1}`;
  };

  useEffect(() => {
    if (
      window.location.href.split("?page=").length !== 2 ||
      isNaN(window.location.href.split("?page=")[1])
    ) {
      window.location.href = `/video?page=1`;
    }
    setSelectedPage(window.location.href.split("page=")[1] - 1);
    getYoutubePageCount().then((response) => {
      setYoutubeCount(response.data);
    });
  }, []);

  return (
    <div className="h-screen w-screen min-w-[1200px]">
      <MenuBar selected_page={11} />
      <div className="w-full bg-white">
        <div className="youtube_banner">
          <a
            href="https://www.youtube.com/channel/UCSUW_pGH6ru65irfT4I7sog"
            target="_blank"
            rel="noreferrer"
          >
            <div className="youtube_image">
              <img src={youtubeLink} className="youtube_link" />
            </div>
          </a>
        </div>
        <VideoList
          pageCount={youtubeCount}
          changePage={changePage}
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          setYoutubeCount={setYoutubeCount}
        />
      </div>
      <Address />
    </div>
  );
};
